import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import {forwardRef} from 'react';
import {cn} from '../lib/utils';

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

const CollapsibleContent = forwardRef<
  HTMLDivElement,
  CollapsiblePrimitive.CollapsibleContentProps & {zoom?: boolean}
>(({className, zoom, ...props}, forwardedRef) => {
  return (
    <CollapsiblePrimitive.CollapsibleContent
      {...props}
      className={cn(
        'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        zoom && 'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95',
        'data-[state=closed]:h-0',
        className,
      )}
      ref={forwardedRef}
    />
  );
});
CollapsibleContent.displayName = 'CollapsibleContent';

export {Collapsible, CollapsibleTrigger, CollapsibleContent};
